var logger = {
    reservationNumber: '',
    eventGroup: '',
    eventName: '',
    eventAdditionalData: '',
    eventAdditionalFields: [],
    eventResult: false,
    eventDescription: '',
    transactionOrderId: '',
    setReservationNumber: function(reservationNumber) {
        this.reservationNumber = reservationNumber;
    },
    setEventGroup: function(eventGroup) {
        this.eventGroup = eventGroup;
    },
    setEventName: function(eventName) {
        this.eventName = eventName;
    },
    setEventAdditionalData: function(eventAdditionalData) {
        this.eventAdditionalData = eventAdditionalData;
    },
    setEventResult: function(eventResult) {
        this.eventResult = eventResult;
    },
    setEventDescription: function(eventDescription) {
        this.eventDescription = eventDescription;
    },
    setTransactionOrderId: function(transactionOrderId) {
        this.transactionOrderId = transactionOrderId;
    },
    setEventAdditionalFields: function(eventAdditionalFields) {
        this.eventAdditionalFields = eventAdditionalFields;
    },
    logEvent: function() {
        let url = _d.url.pageEventLog;
        let dataPayload = {
            reservationNumber: this.reservationNumber,
            eventGroup: this.eventGroup,
            eventName: this.eventName,
            eventAdditionalData: this.eventAdditionalData,
            eventAdditionalFields: this.eventAdditionalFields,
            eventResult: this.eventResult,
            eventDescription: this.eventDescription,
            transactionOrderId: this.transactionOrderId
        };
        $.ajax({
            url: url,
            type: 'POST',
            data: dataPayload
        });

        if (_d.isWebView) {
            /* eslint-disable-next-line no-console */
            console.log('URL: ' + url + '\n' + 'Data: ' + JSON.stringify(dataPayload));
        }
    }
};
